import React from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
const TechPlatformBanner = ({ onLoad }) => {
  return (
    <>
      <BannerWrapper onLoad={onLoad}>
        {({ useHighRes, imageLoaded, handleImageLoad }) => (
          <div
            className="container-fluid ctm-banner position-relative p-0"
            style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
          >
            <img
              src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/12.%20Our%20Tech%20Platforms.webp"
              alt="Tech Platform Banner"
              className="w-100"
              loading={useHighRes ? "eager" : "lazy"}
              onLoad={handleImageLoad}
              fetchpriority={useHighRes ? "high" : "auto"}
            />
            {imageLoaded ? (
              <div className="ctm-text position-absolute text-white mt-md-4 mt-3">
                <p className="fs4 text-uppercase busy">OUR TECH PLATFORMS</p>
                <h1 className="banner-headings w-75">
                  Revolutionizing Travel Through Technology
                </h1>
                <div className="d-flex common-second-content">
                  <div className="ornge-border"></div>
                  <div className="second-content">
                    Why settle for outdated travel solutions? From easy bookings
                    to instant updates and expense tracking, we provide the
                    tools that keep your business moving forward effortlessly.
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </BannerWrapper>
    </>
  );
};

export default TechPlatformBanner;
